// extracted by mini-css-extract-plugin
export default {"link":"uO-z","disabled":"vO-z"};